export const userInputs = [
  {
    id: 'username',
    label: 'Username',
    type: 'text',
    placeholder: 'john_doe',
  },
  {
    id: 'displayName',
    label: 'Name and surname',
    type: 'text',
    placeholder: 'John Doe',
  },
  {
    id: 'email',
    label: 'Email',
    type: 'mail',
    placeholder: 'john_doe@gmail.com',
  },
  {
    id: 'phone',
    label: 'Phone',
    type: 'text',
    placeholder: '+1 234 567 89',
  },
  {
    id: 'password',
    label: 'Password',
    type: 'password',
  },
  {
    id: 'address',
    label: 'Address',
    type: 'text',
    placeholder: 'Elton St. 216 NewYork',
  },
  {
    id: 'country',
    label: 'Country',
    type: 'text',
    placeholder: 'USA',
  },
];

export const photoInputs = [
  {
    id: 1,
    label: 'Title',
    type: 'text',
    placeholder: 'Apple Macbook Pro',
  },
  {
    id: 2,
    label: 'Description',
    type: 'text',
    placeholder: 'Description',
  },
  {
    id: 3,
    label: 'Category',
    type: 'text',
    placeholder: 'Computers',
  },
  {
    id: 4,
    label: 'Date',
    type: 'text',
    placeholder: '10/12/2012',
  },
  {
    id: 5,
    label: 'Size',
    type: 'text',
    placeholder: '32MB',
  },
];
